export var getCartulina = function getCartulina(state) {
  return state.cartulina;
};
export var getActiva = function getActiva(state) {
  return getCartulina(state).activa;
};
export var getVisible = function getVisible(state) {
  return getCartulina(state).visible;
};
export var getRecortes = function getRecortes(state) {
  return getCartulina(state).recortes;
};